import {
  Image,
  View,
  type ImageSourcePropType,
  type ImageStyle,
  type StyleProp,
  type ViewStyle,
} from "react-native";
import { CardSurface } from "@louise/moon-ui";
import { TINTED_ICON_FILTER } from "./icons";

// ── Row Illustration ──

/**
 * The single canonical size for the 3D illustrations that lead You rows.
 * Sections previously each declared their own (26/28/30/32), which is why the
 * same icon family rendered at different scales from one section to the next.
 */
export const YOU_ILLUSTRATION_SIZE = 28;

/**
 * The one illustration primitive for You rows. Every section renders its 3D
 * icon through this so scale, fit, and alignment stay identical across the
 * screen — `contain` keeps non-square sources from being cropped or stretched.
 */
export function YouIllustration({
  source,
  tinted = false,
  style,
}: {
  source: ImageSourcePropType;
  /** Web-only warm tint, used where rows sit on a tinted surface. */
  tinted?: boolean;
  /** Optical alignment nudges only — never width or height. */
  style?: StyleProp<ImageStyle>;
}) {
  return (
    <Image
      source={source}
      resizeMode="contain"
      style={[
        {
          width: YOU_ILLUSTRATION_SIZE,
          height: YOU_ILLUSTRATION_SIZE,
          ...(tinted ? TINTED_ICON_FILTER : null),
        },
        style,
      ]}
    />
  );
}

// ── Grouped Card ──

export function GroupedCard({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: ViewStyle;
}) {
  return (
    <CardSurface style={[{ marginBottom: 20 }, style]}>{children}</CardSurface>
  );
}

// ── Status Dot ──

export function StatusDot({ color }: { color: string }) {
  return (
    <View
      style={{
        width: 6,
        height: 6,
        borderRadius: 3,
        backgroundColor: color,
      }}
    />
  );
}
